import { Card, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { EyeFill, PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";
import HelperService from "../../utility/HelperService";
import AddAdminUser from "./AddOrganization";
import { toast } from "react-toastify";
import ViewOrganization from "./ViewOrganization";

interface PropData {
    data: OrganizationInterface | null
}

const RESOURCE_TYPE_LABELS: Record<string, string> = {
  INDUSTRY: "INDUSTRY",
  KNWGROUP: "KNOWLEDGE",
  PRESENTATION: "PRESENTATION",
  WRKGROUP: "WORKING_GROUP",
  REGULATION: "REGULATION",
  TENDERS: "TENDERS",
};

export interface OrganizationInterface {
    _id: number
    name: string;
    email?: string | null;
    phone?: string | null;
    website?: string | null;
    category?: string | null;
    gstNumber?: string | null;
    logo?: string | null;
    country: string | number | null;
    state: string | number | null;
    city: string | number | null;
    pinCode: string | null;
    address?: string | null;
    status: OrganizationStatus;
    type: OrganizationType;
}

export enum OrganizationStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    DELETED = 'DELETED'
}

export enum OrganizationType {
    ORGANIZATION = 'ORGANIZATION',
    PERSONAL = 'PERSONAL'
}

const columns = [
    {
        id: "title",
        label: "Report Name",     // changed Title  to report name as client feedback
        minWidth: 170,
        sortable: true,
    },

    {
        id: "type",
        label: "Resource Type",      // changed Type to Resource Type as client feedback 
        minWidth: 170,
        sortable: true,
    },
    {
        id: "downloaded_by",
        label: "Downloaded By",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "downloaded_on",
        label: "Downloaded On",
        minWidth: 170,
        sortable: true,
    },
    // {
    //     id: "createdAt",            // removed as client feedback 
    //     label: "Created Date",
    //     minWidth: 170,
    //     sortable: true,
    // },
    // {
    //     id: "action",
    //     label: "Action",
    //     minWidth: 100,
    //     align: "center" as const,
    // },
];


const Resources = (props: PropData) => {
    const [showAdminBlade, setShowAdminBlade] = useState(false);
    const [leadershipCouncils, setLeadershipCouncils] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [leadershipCouncilToDelete, setLeadershipCouncilToDelete] = useState<string | null>(null);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [search, setSearch] = useState("");
    const [sortField, setSortField] = useState<string>("downloaded_on");
    const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
    const [uiSortField, setUiSortField] = useState<string>("downloaded_on");
    const [loading, setLoading] = useState<boolean>(false);
    const sortFieldMap: Record<string, string> = {
        title: "finalItem.title",
        type: "finalItem.itemCategory",
        downloaded_by: "user.fullName",
        downloaded_on: "downloaded_on",
    };
    const [userObject, setUserObject] = useState<OrganizationInterface | null>(null)
    const [showOrganizationView, setShowOrganizationView] = useState(false);

    console.log("propsData", props.data);

    // const getResourceTypeLabel = (type?: string) =>
    // type ? RESOURCE_TYPE_LABELS[type] || type : "-";

    useEffect(() => {
        getOrganizationResourcesList();
    }, [currentPage, sortField, sortOrder]);

    const getOrganizationResourcesList = (keyword: string = "") => {
        setLoading(true);
        const params = new URLSearchParams();
        params.append("page", currentPage.toString());
        params.append("limit", itemsPerPage.toString());

        // Keyword searches
        if (keyword.trim()) {
            params.append("keyword", keyword.trim());
        }

        // Sorting
        params.append("sortField", sortField);
        params.append("sortOrder", sortOrder);

        if (!props?.data?._id) {
            setLoading(false);
            return;
        }
        WebService.getAPI({
            action: `organizations/get-resource-list/${props.data._id}?${params.toString()}`,
        })
            .then((res: any) => {
                const formattedRows = res?.data?.data.map((item: any) => {
                    return {
                        title: item.finalItem?.title || "-",
                        type: HelperService.getResourceTypeLabel(item.finalItem?.itemCategory),
                        downloaded_by: item.user?.fullName || "-",
                        downloaded_on: HelperService.getFormatedDate(item.downloaded_on),
                        // createdAt: HelperService.getFormatedDate(item.createdAt),
                    };
                });
                setLeadershipCouncils(formattedRows);
                setTotalCount(res?.data?.pagination?.total);
            })
            .catch((err: any) => {
                console.error("Error fetching organization resources:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };


    const handleDeleteEvent = (leadershipCouncilId: string) => {
        setLeadershipCouncilToDelete(leadershipCouncilId);
        setShowDeleteModal(true);
    };

    const actionList = (item: any) =>
    (
        <div>
            <PencilFill className="me-3 cursor-pointer" size={16}
                onClick={() => {
                    setShowAdminBlade(true);
                    setUserObject(item);
                }}
                title="Edit"
            />
            <EyeFill className="me-3 cursor-pointer" size={18}
                onClick={() => {
                    setShowOrganizationView(true);
                    setUserObject(item);
                }}
                title="View"
            />
        </div>
    );
    return (
        <>
            <AddAdminUser show={showAdminBlade}
                handleClose={() => { setShowAdminBlade(false); getOrganizationResourcesList(); setUserObject(null); }}
                data={userObject}
            />
            <ViewOrganization show={showOrganizationView}
                handleClose={() => { setShowOrganizationView(false); getOrganizationResourcesList(); setUserObject(null); }}
                data={userObject}
            />
            <DeleteModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onDelete={() => {
                    if (leadershipCouncilToDelete) {
                        WebService.deleteAPI({
                            action: `admin-user/delete-admin-user/${leadershipCouncilToDelete}`,
                        }).then(() => {
                            setShowDeleteModal(false);
                            toast.success("Admin User deleted successfully.");
                            getOrganizationResourcesList();
                        });
                    }
                }}
                message="Are you sure you want to delete ?"
            />
            <div className="card">
                <div className="card-body">
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <Form.Label className="label">Search</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="search"
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setCurrentPage(1);
                                    getOrganizationResourcesList(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <div >
                            <CustomTableSortable
                                columns={columns}
                                rows={leadershipCouncils}
                                totalCount={totalCount}
                                currentPage={currentPage}
                                pageSize={itemsPerPage}
                                onPageChange={(page) => {
                                    setCurrentPage(page);
                                }}
                                isLoading={loading}
                                sortField={uiSortField}
                                sortOrder={sortOrder}
                                onSortChange={(columnId, order) => {
                                    setUiSortField(columnId);
                                    setSortOrder(order);
                                    const apiField = sortFieldMap[columnId] || "downloaded_on";
                                    setSortField(apiField);
                                    setCurrentPage(1);
                                    // Fetch is driven by the useEffect (now depends on sortField/sortOrder) using fresh state.
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Resources;
